export const fr = {
	flag: '🇫🇷',
	name: 'Français',
	code: 'fr',
	nav: {
		services: 'Services',
		realizations: 'Réalisations',
		about: 'À propos',
		cta: 'Démarrer un projet',
		contact: 'Contact',
		skip: 'Aller au contenu principal',
		mainLabel: 'Navigation principale',
		homeLabel: 'Kuba Studio, accueil',
		langShort: 'EN',
		langSwitchLabel: 'Switch to English',
		themeToDark: 'Passer en thème sombre',
		themeToLight: 'Passer en thème clair',
		openMenu: 'Ouvrir le menu',
		closeMenu: 'Fermer le menu',
	},
	hero: {
		badge: 'Studio digital · Île-de-France',
		tagline:
			"Studio spécialisé dans les applications web & mobiles, solutions logicielles et plateformes SaaS.",
		ctaRealizations: 'Voir nos réalisations',
		ctaContact: 'Démarrer un projet',
		stat1Value: 'Web & Mobile',
		stat1Label: 'Applications',
		stat2Value: 'SaaS & Logiciels',
		stat2Label: 'Solutions',
		stat3Value: '2025',
		stat3Label: 'Fondé',
		h1Line1: "De l'idée",
		h1Pre: 'au',
		h1Accent: 'produit fini,',
		h1Line3: 'ensemble.',
		floatMobileTitle: 'Web, iOS & Android',
		floatMobileSub: 'Coasso, en bêta',
		floatProdTitle: 'En production',
		floatProdSub: 'des produits réels',
		techLabel: 'Technologies utilisées',
		scrollText: 'Découvrir',
	},
	services: {
		eyebrow: 'Expertise',
		title: 'Ce que nous faisons',
		subtitle:
			"Du concept à la production, nous couvrons l'ensemble du spectre du développement digital.",
		learnMore: 'En savoir plus',
		webTitle: 'Applications Web',
		webDesc: 'Interfaces modernes et plateformes digitales performantes construites pour durer.',
		webF1: 'Next.js & React',
		webF2: 'Single Page Applications',
		webF3: 'Dashboards & backoffices',
		webF4: 'SEO & performance',
		mobileTitle: 'Applications Mobiles',
		mobileDesc: "Apps iOS et Android natives et cross-platform, de la maquette au store.",
		mobileF1: 'React Native & Flutter',
		mobileF2: 'iOS & Android',
		mobileF3: 'UI/UX design',
		mobileF4: 'Déploiement App Store',
		softwareTitle: 'Solutions Logicielles',
		softwareDesc: "Logiciels sur mesure, APIs et intégrations adaptés à vos processus métier.",
		softwareF1: 'APIs REST & GraphQL',
		softwareF2: 'Logiciels desktop',
		softwareF3: 'Automatisations',
		softwareF4: 'Intégrations tierces',
		saasTitle: 'Plateformes SaaS',
		saasDesc: 'Architecture cloud scalable, multi-tenant, prête pour la croissance.',
		saasF1: 'Architecture cloud',
		saasF2: 'Multi-tenant',
		saasF3: 'Scalabilité & monitoring',
		saasF4: 'Facturation & abonnements',
	},
	realizations: {
		eyebrow: 'Nos réalisations',
		title: 'Ce que nous avons construit',
		subtitle:
			'Projets internes et clients — des produits réels, en production, utilisés quotidiennement.',
		loading: 'Chargement…',
		visitSite: 'Visiter le site',
		coasso: {
			name: 'Coasso — pour les membres',
			alt: "Page d'accueil de Coasso",
			tag: 'Bêta · Web, iOS & Android',
			description:
				"L'application des adhérents : trouver une association près de chez soi, s'inscrire, payer sa cotisation en ligne et suivre ses activités, avec une carte des clubs pour découvrir ce qui existe autour de soi.",
			stack: ['Flutter', 'Go', 'PostgreSQL', 'Stripe'],
		},
		coassopro: {
			name: 'Coasso Pro — pour les associations',
			alt: "Page d'accueil de Coasso Pro",
			tag: 'Bêta · SaaS',
			description:
				"L'outil de gestion des dirigeants d'associations sportives, culturelles et solidaires : adhérents et inscriptions, paiements en ligne encaissés directement par l'association, planning, formulaires, messagerie et rôles. Gratuit pendant la bêta, conforme RGPD, données hébergées en Europe.",
			stack: ['Flutter', 'Go', 'Cloud Run', 'Stripe Connect'],
		},
		patrol: {
			name: 'Patrol',
			alt: "Page d'accueil du site Patrol",
			tag: 'Application Web',
			description:
				"Site web réalisé pour Patrol, entreprise spécialisée dans la sécurité privée et la surveillance terrain.",
			stack: ['Next.js', 'Firebase', 'TypeScript', 'Tailwind CSS'],
		},
		novaccord: {
			name: 'Novaccord',
			alt: "Page d'accueil du site Novaccord",
			tag: 'Site Vitrine',
			description:
				"Site vitrine d'une société de médiation, conçu pour présenter l'accompagnement de Novaccord dans la prévention et la résolution des conflits entre professionnels.",
			stack: ['Next.js', 'TypeScript', 'Tailwind CSS'],
		},
		picstat: {
			name: 'Picstat',
			alt: "Page d'accueil de Picstat",
			tag: 'Application Mobile',
			description:
				"Application de montage photo et vidéo avec overlays générés depuis vos activités Strava — tracé GPX, statistiques et données d'entraînement superposés à vos contenus.",
			stack: ['React Native', 'Expo', 'TypeScript', 'Firebase'],
		},
		tivea: {
			name: 'Tivea',
			alt: 'Écran de déclaration de TVA dans Tivea',
			tag: 'Application Mac & iOS',
			description:
				"Application Mac, iPad et iPhone de gestion financière pour entreprises : achats, encaissements, comptes bancaires et déclarations de TVA, avec des données chiffrées qui restent chez vous.",
			stack: ['Swift', 'SwiftUI', 'CryptoKit', 'iCloud'],
		},
		discoverApp: "Découvrir l'app",
		newTab: '(nouvel onglet)',
		screenshotAlt: "capture de l'application",
	},
	about: {
		eyebrow: 'À propos',
		title: 'Kuba Studio',
		subtitle: "Un studio fondé sur la rigueur technique et l'ambition produit.",
		statementPre: 'Un studio fondé sur la rigueur technique et ',
		statementAccent: "l'ambition produit.",
		headline: "De l'idée au produit fini, ensemble.",
		para1:
			"Kuba Studio est un studio de développement spécialisé dans la conception et le lancement d'applications web & mobiles, de solutions logicielles et de plateformes SaaS.",
		para2:
			"Nous construisons des produits de qualité — aussi bien nos propres outils que des solutions sur mesure pour nos clients — avec les mêmes standards d'excellence.",
		para3:
			"Notre approche : du code propre, une architecture solide et une attention constante à l'expérience utilisateur.",
		missionTitle: 'Notre mission',
		missionDesc: 'Rendre la technologie accessible et créer des produits qui ont un impact réel.',
		velocityTitle: 'Notre approche',
		velocityDesc: 'Shipping rapide, itérations courtes, qualité non négociable.',
		qualityTitle: 'Nos standards',
		qualityDesc: 'Code propre, architecture solide, documentation et tests à chaque étape.',
		stat1Value: '5',
		stat1Label: 'Projets réalisés',
		stat2Value: 'Web · Mobile · SaaS · Logicielle',
		stat2Label: 'Expertises',
		stat3Value: '2025',
		stat3Label: 'Fondé',
	},
	contact: {
		eyebrow: 'Contact',
		title: 'Parlons de votre projet',
		subtitle: 'Une idée ? Un projet en cours ? Écrivez-nous, on répond vite.',
		formTitle: 'Transformons vos idées en réalité',
		formDesc:
			"Que vous ayez un projet précis ou une simple idée, nous sommes là pour vous accompagner de la conception au lancement.",
		emailLabel: 'Email',
		locationLabel: 'Localisation',
		locationValue: 'Île-de-France',
		nameLabel: 'Nom',
		emailPlaceholder: 'votre@email.com',
		companyPlaceholder: 'Entreprise (optionnel)',
		messageLabel: 'Message',
		messagePlaceholder: 'Décrivez votre projet…',
		nameError: 'Le nom doit contenir au moins 3 caractères.',
		emailError: 'Adresse email invalide.',
		messageError: 'Le message doit contenir au moins 10 caractères.',
		sendButton: 'Envoyer',
		sendingButton: 'Envoi en cours…',
		successMessage: 'Message envoyé ! Nous vous répondrons très bientôt.',
		sendAnother: 'Envoyer un autre message',
		errorMessage: 'Une erreur est survenue. Veuillez réessayer.',
	},
	footer: {
		tagline: 'Studio spécialisé dans les applications web & mobiles, solutions logicielles et SaaS.',
		navLabel: 'Navigation',
		services: 'Services',
		realizations: 'Réalisations',
		about: 'À propos',
		contact: 'Contact',
		projectsLabel: 'Projets',
		legal: 'Mentions légales',
		followLabel: 'Suivre',
		location: 'Île-de-France',
		linkedin: 'LinkedIn',
		linkedinAria: 'Kuba Studio sur LinkedIn (nouvel onglet)',
		emailAria: 'Écrire à contact@kuba-studio.com',
		newTab: '(nouvel onglet)',
		homeAria: 'Kuba Studio, haut de page',
		copyright: 'Tous droits réservés.',
	},
	legalPage: {
		title: 'Mentions Légales',
		lastUpdate: 'Dernière mise à jour',
		publisherTitle: 'Éditeur du site',
		companyName: 'Raison sociale',
		companyNameValue: 'Kuba Studio',
		legalStatus: 'Forme juridique',
		legalStatusValue: 'SASU',
		headquarters: 'Siège social',
		headquartersValue: '57 bis rue du chêne, 77380 Combs-la-Ville, France',
		siren: 'SIREN',
		sirenValue: '993 476 357',
		vat: 'N° TVA intracommunautaire',
		vatValue: 'FR02993476357',
		capital: 'Capital social',
		capitalValue: '2 000 €',
		contact: 'Contact',
		contactValue: 'contact@kuba-studio.com',
		hostingTitle: 'Hébergeur',
		hostingName: 'Nom',
		hostingNameValue: 'Google Cloud Platform',
		hostingCompany: 'Société',
		hostingCompanyValue: 'Google LLC',
		hostingAddress: 'Adresse',
		hostingAddressValue: '1600 Amphitheatre Parkway, Mountain View, CA 94043, États-Unis',
		ipTitle: 'Propriété intellectuelle',
		ipContent:
			"L'ensemble de ce site (design, logos, textes, images, code source) est la propriété exclusive de Kuba Studio et est protégé par le droit d'auteur. Toute reproduction ou utilisation sans autorisation est interdite.",
	},
	privacyTivea: {
		title: 'Politique de confidentialité — Tivea',
		lastUpdate: 'Dernière mise à jour',
		summaryTitle: 'En résumé',
		summary:
			"Tivea ne collecte aucune donnée. L'application fonctionne entièrement sur votre appareil : aucune information n'est transmise à Kuba Studio ni à un tiers.",
		scope:
			"Cette politique décrit le traitement des données dans l'application Tivea pour macOS et iOS, éditée par Kuba Studio.",
		noCollectionTitle: 'Aucune collecte de données',
		noCollectionIntro:
			'Nous ne collectons, ne stockons et ne transmettons aucune donnée personnelle. Concrètement :',
		noCollectionItems: [
			'Aucun compte, aucune inscription, aucun identifiant à fournir.',
			"Aucune statistique d'usage, aucun outil d'analyse, aucun traceur.",
			'Aucune publicité et aucun SDK publicitaire.',
			'Aucun kit de développement tiers susceptible de collecter des données.',
			"Aucun serveur : l'application ne communique avec aucun service de Kuba Studio.",
		],
		storageTitle: 'Où sont vos données',
		storageIntro:
			"Toutes les données que vous saisissez (achats, encaissements, comptes bancaires, virements, déclarations de TVA) sont enregistrées dans un fichier .tivea dont vous choisissez l'emplacement :",
		storageItems: [
			'sur votre appareil : disque local, ou volume réseau / NAS de votre choix ;',
			'ou dans votre espace iCloud, si vous activez cette option.',
		],
		storageNote:
			"Dans le cas d'iCloud, la synchronisation est assurée par Apple entre vos propres appareils, sous votre compte Apple. Kuba Studio n'y a aucun accès.",
		encryptionTitle: 'Chiffrement',
		encryptionIntro:
			'Le contenu de vos fichiers est chiffré avec AES-GCM 256 bits. La clé de chiffrement est, selon votre choix :',
		encryptionItems: [
			"dérivée d'un mot de passe que vous seul connaissez (PBKDF2-HMAC-SHA256) ;",
			'ou générée aléatoirement et conservée dans le Trousseau de votre appareil.',
		],
		encryptionNote:
			"Votre mot de passe n'est jamais transmis ni stocké : nous ne pouvons pas récupérer vos données si vous le perdez.",
		rightsTitle: 'Vos droits (RGPD)',
		rightsContent:
			"Ne détenant aucune donnée vous concernant, nous n'avons rien à consulter, rectifier, exporter ou supprimer. Vous gardez le contrôle total de vos fichiers : vous pouvez les copier, les déplacer ou les supprimer directement depuis votre appareil.",
		childrenTitle: 'Enfants',
		childrenContent:
			"Tivea est un outil de gestion financière professionnelle et ne s'adresse pas aux enfants. Aucune donnée n'étant collectée, aucune donnée d'enfant ne peut l'être.",
		changesTitle: 'Modifications',
		changesContent:
			'Toute évolution de cette politique sera publiée sur cette page, avec une date de mise à jour actualisée.',
		contactTitle: 'Contact',
		contactContent: 'Pour toute question relative à cette politique :',
		contactEmail: 'contact@kuba-studio.com',
	},
	supportTivea: {
		title: 'Support — Tivea',
		intro:
			"Besoin d'aide avec Tivea ? Écris-nous, on répond sous 48 h ouvrées. Voici déjà les questions les plus fréquentes.",
		contactTitle: 'Nous contacter',
		contactContent: 'Une question, un bug, une suggestion :',
		contactEmail: 'contact@kuba-studio.com',
		faqTitle: 'Questions fréquentes',
		faq: [
			{
				q: 'Où sont stockées mes données ?',
				a: "Dans un fichier .tivea dont vous choisissez l'emplacement : sur votre Mac ou iPhone, sur un volume réseau / NAS, ou dans votre iCloud. Tout est chiffré en AES-256. Nous n'y avons jamais accès.",
			},
			{
				q: "J'ai perdu mon mot de passe, que faire ?",
				a: "Le mot de passe n'est jamais transmis ni stocké : il est impossible de récupérer un coffre protégé dont le mot de passe est perdu. C'est le prix d'un chiffrement réellement sûr. Pensez à le conserver dans un gestionnaire de mots de passe.",
			},
			{
				q: 'Comment synchroniser entre mon Mac et mon iPhone ?',
				a: "À la création du coffre, choisissez l'emplacement « iCloud ». Le fichier se synchronise alors automatiquement entre vos appareils connectés au même compte Apple. Vérifiez qu'iCloud Drive est activé.",
			},
			{
				q: 'Comment importer mon relevé bancaire ?',
				a: "Section Comptes → « Importer un relevé ». Tivea lit les fichiers CSV et OFX. Pour un CSV, vous choisissez les colonnes (date, libellé, montant) et un aperçu s'affiche : les montants négatifs deviennent des achats, les positifs des encaissements.",
			},
			{
				q: 'Comment est calculée la TVA ?',
				a: "Régime réel normal (CA3 mensuelle) : TVA collectée sur vos encaissements moins TVA déductible sur vos achats. Si le mois dégage un crédit, vous choisissez de le reporter sur le mois suivant ou d'en demander le remboursement.",
			},
			{
				q: 'Tivea remplace-t-elle un expert-comptable ?',
				a: "Non. Tivea vous aide à suivre vos opérations et à préparer vos déclarations, mais les montants restent indicatifs et sous votre responsabilité. Reportez-les sur votre déclaration officielle et faites valider votre comptabilité par un professionnel.",
			},
		],
		requirementsTitle: 'Configuration requise',
		requirementsContent: 'macOS 14.4 ou ultérieur — iOS 17.4 ou ultérieur, iPad compris. Achat unique, valable sur Mac, iPad et iPhone.',
	},
	tiveaPage: {
		badge: 'App Mac · iPad · iPhone',
		tagline: 'Votre gestion financière et votre TVA, sans prise de tête.',
		intro:
			"Suivez vos achats, encaissements et comptes bancaires, et préparez vos déclarations de TVA en quelques minutes. Vos données sont chiffrées et restent chez vous.",
		appStoreSmall: 'Télécharger dans',
		appStoreBig: "l'App Store",
		supportLink: 'Aide & support',
		meta: 'Achat unique · macOS 14.4+ · iOS 17.4+',
		heroChips: ['Chiffré AES-256', 'TVA calculée', 'Sync iCloud'],
		iconAlt: "Icône de l'application Tivea",
		galleryAria: "Captures d'écran de Tivea",
		galleryEyebrow: 'Aperçu',
		galleryTitle: "L'app en images",
		gallerySubtitle: 'Une interface claire et native, pensée pour aller vite.',
		gallery: ['Tableau de bord', 'Déclaration de TVA', 'Rapports', 'Comptes bancaires', 'Échéances'],
		featuresEyebrow: 'Fonctionnalités',
		featuresTitle: 'Tout votre suivi, au même endroit',
		featuresSubtitle: "Pensée pour les dirigeants et indépendants qui veulent y voir clair, sans logiciel comptable complexe.",
		features: [
			{
				title: 'TVA calculée automatiquement',
				desc: "TVA collectée moins TVA déductible, mois par mois (CA3) ou à l'année (CA12), avec report du crédit de TVA sur la période suivante.",
			},
			{
				title: 'Comptes & relevés bancaires',
				desc: 'Importez vos relevés CSV ou OFX : les dépenses deviennent des achats, les recettes des encaissements. Les doublons sont détectés.',
			},
			{
				title: 'Factures & clients',
				desc: 'Éditez vos factures, suivez vos clients et vos encaissements, et joignez vos justificatifs à chaque opération.',
			},
			{
				title: 'Rapports & exports',
				desc: "Tableau de bord, rapports, export PDF et fichiers prêts à transmettre à votre expert-comptable.",
			},
			{
				title: 'Chiffré de bout en bout',
				desc: 'Chaque fichier .tivea est chiffré en AES-GCM 256 bits, protégé par mot de passe ou par le Trousseau de votre appareil.',
			},
			{
				title: 'Mac, iPad et iPhone',
				desc: 'Une app native SwiftUI, synchronisée via votre iCloud. Un seul achat pour tous vos appareils.',
			},
		],
		privacyEyebrow: 'Confidentialité',
		privacyTitle: 'Vos chiffres ne regardent que vous',
		privacyDesc:
			"Tivea fonctionne entièrement sur votre appareil. Pas de compte, pas de serveur, pas de traceur : Kuba Studio n'a jamais accès à vos données.",
		privacyPoints: [
			'Aucune donnée collectée, aucune statistique d’usage.',
			'Fichiers stockés où vous voulez : Mac, NAS ou iCloud.',
			'Chiffrement AES-256, mot de passe jamais transmis.',
			'Aucune publicité, aucun SDK tiers.',
		],
		privacyLink: 'Lire la politique de confidentialité',
		ctaTitle: 'Prêt à reprendre la main sur vos comptes ?',
		ctaDesc: 'Téléchargez Tivea sur votre Mac, iPad ou iPhone et préparez votre prochaine déclaration de TVA en toute sérénité.',
		privacyPolicyLink: 'Politique de confidentialité',
		disclaimer:
			"Tivea vous aide à suivre vos opérations et à préparer vos déclarations ; les montants restent indicatifs et ne remplacent pas l'avis d'un expert-comptable.",
	},
};
